import { BaseFetch } from "../main-model"
export default class cumulativeModel extends BaseFetch {
  getCumulativeBy = (data) =>
    this.authFetch({
      url: "cumulative/getcumulativeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getCumulativeById = (data) =>
    this.authFetch({
      url: "cumulative/getcumulativeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateCumulativeById = (data) =>
    this.authFetch({
      url: "cumulative/updatecumulativeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertCumulative = (data) =>
    this.authFetch({
      url: "cumulative/insertcumulative",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteCumulativeById = (data) =>
    this.authFetch({
      url: "cumulative/deletecumulativeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
